var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 22,
    viewBox: "0 0 20 22",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M12.1516 7.19877L7.2967 7.86783L7.12286 8.75368L8.07688 8.94717C8.70017 9.11036 8.82313 9.35747 8.68745 10.0405L7.12286 18.1251C6.71157 20.2162 7.34547 21.2 8.83585 21.2C9.99128 21.2 11.3333 20.6125 11.9417 19.8059L12.1283 18.8362C11.7043 19.2464 11.0852 19.4096 10.6739 19.4096C10.0909 19.4096 9.87891 18.9597 10.0294 18.1671L12.1516 7.19877ZM12.3 2.33121C12.3 2.94948 12.0766 3.54243 11.6791 3.97962C11.2815 4.41681 10.7422 4.66242 10.18 4.66242C9.61769 4.66242 9.07845 4.41681 8.68086 3.97962C8.28328 3.54243 8.05992 2.94948 8.05992 2.33121C8.05992 1.71293 8.28328 1.11998 8.68086 0.682795C9.07845 0.245609 9.61769 0 10.18 0C10.7422 0 11.2815 0.245609 11.6791 0.682795C12.0766 1.11998 12.3 1.71293 12.3 2.33121Z",
    fill: "#E66100"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIIcon);
export default __webpack_public_path__ + "static/media/i-icon.2450f245ff60c35ac9b2add0f17b85da.svg";
export { ForwardRef as ReactComponent };